// import React, { useState, useEffect } from "react";
// import { 
//   FaCheckCircle, 
//   FaExclamationTriangle, 
//   FaClock, 
//   FaDatabase, 
//   FaShieldAlt, 
//   FaGavel, 
//   FaBook, 
//   FaTimes, 
//   FaArrowRight 
// } from "react-icons/fa";

// const TermsConditions = ({ isMobile, autoAgree = false }) => {
//     const [agreed, setAgreed] = useState(false);
//     const [showSuccessModal, setShowSuccessModal] = useState(false);

//     useEffect(() => {
//         if (autoAgree) {
//             setAgreed(true);
//         }
//     }, [autoAgree]);

//     const handleNext = () => {
//         if (!agreed) {
//             alert("Please read and agree to the Terms & Conditions before proceeding.");
//             return;
//         }

//         const data = {
//             agreed: true,
//             agreedDate: new Date().toISOString(),
//             vendorId: localStorage.getItem("vendorId") || "",
//             vendorName: localStorage.getItem("vendorName") || "",
//             termsVersion: "v1.5",
//             submissionId: `TNC-${Date.now()}`,
//             vendorEmail: localStorage.getItem("vendorEmail") || "vendor@example.com"
//         };

//         console.log("Terms & Conditions agreed:", data);
//         setShowSuccessModal(true);
//     };

//     const handleBack = () => {
//         // This would typically navigate back
//         console.log("Navigate back to Privacy Policy");
//     };

//     const SuccessModal = ({ isOpen, onClose, message, title = "Success!" }) => {
//         if (!isOpen) return null;
      
//         return (
//           <div style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 9999,
//             padding: '20px'
//           }}>
//             <div style={{
//               backgroundColor: 'white',
//               borderRadius: '12px',
//               padding: window.innerWidth < 768 ? '20px' : '30px',
//               maxWidth: window.innerWidth < 768 ? '90%' : '500px',
//               width: '100%',
//               boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//               position: 'relative'
//             }}>
//               <button 
//                 onClick={onClose}
//                 aria-label="Close success modal"
//                 style={{
//                   position: 'absolute',
//                   top: '15px',
//                   right: '15px',
//                   background: 'none',
//                   border: 'none',
//                   fontSize: '20px',
//                   color: '#666',
//                   cursor: 'pointer',
//                   width: '30px',
//                   height: '30px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   borderRadius: '50%',
//                   transition: 'all 0.3s ease'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.backgroundColor = '#f5f5f5';
//                   e.currentTarget.style.color = '#333';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.backgroundColor = 'transparent';
//                   e.currentTarget.style.color = '#666';
//                 }}
//               >
//                 <FaTimes aria-hidden="true" />
//               </button>
      
//               <div style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 marginBottom: '20px'
//               }}>
//                 <div style={{
//                   width: '80px',
//                   height: '80px',
//                   borderRadius: '50%',
//                   backgroundColor: '#4CAF50',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   animation: 'scaleIn 0.5s ease-out'
//                 }}>
//                   <FaCheckCircle aria-hidden="true" style={{ color: 'white', fontSize: '40px' }} />
//                 </div>
//               </div>
      
//               <h3 style={{
//                 textAlign: 'center',
//                 color: '#4CAF50',
//                 margin: '0 0 15px 0',
//                 fontSize: window.innerWidth < 768 ? '22px' : '24px',
//                 fontWeight: 'bold'
//               }}>
//                 {title}
//               </h3>
      
//               <div style={{
//                 textAlign: 'center',
//                 color: '#555',
//                 fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                 lineHeight: '1.5',
//                 marginBottom: '25px',
//                 padding: '0 10px'
//               }}>
//                 {message}
//               </div>
      
//               <div style={{ textAlign: 'center' }}>
//                 <button 
//                   onClick={onClose}
//                   aria-label="Close success message"
//                   style={{
//                     backgroundColor: '#4CAF50',
//                     color: 'white',
//                     border: 'none',
//                     padding: window.innerWidth < 768 ? '12px 30px' : '14px 40px',
//                     borderRadius: '50px',
//                     cursor: 'pointer',
//                     fontSize: window.innerWidth < 768 ? '16px' : '18px',
//                     fontWeight: 'bold',
//                     minWidth: '150px',
//                     transition: 'all 0.3s ease',
//                     boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.backgroundColor = '#388E3C';
//                     e.currentTarget.style.transform = 'translateY(-2px)';
//                     e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.backgroundColor = '#4CAF50';
//                     e.currentTarget.style.transform = 'translateY(0)';
//                     e.currentTarget.style.boxShadow = '0 4px 15px rgba(76, 175, 80, 0.3)';
//                   }}
//                 >
//                   OK, Got it!
//                 </button>
//               </div>
//             </div>
      
//             <style>{`
//               @keyframes scaleIn {
//                 from {
//                   transform: scale(0);
//                   opacity: 0;
//                 }
//                 to {
//                   transform: scale(1);
//                   opacity: 1;
//                 }
//               }
//             `}</style>
//           </div>
//         );
//       };

//     return (
//         <div 
//             style={{
//                 backgroundColor: "#fff",
//                 borderRadius: "10px",
//                 padding: isMobile ? "15px" : "25px",
//                 border: "1px solid #e0e0e0",
//                 minHeight: "400px",
//                 overflow: "auto",
//                 scrollbarWidth: "none",
//                 maxHeight: isMobile ? "600px" : "700px"
//             }}
//         >
//             {/* Header */}
//             <header style={{
//                 textAlign: 'center',
//                 marginBottom: '30px'
//             }}>
//                 <h1 style={{
//                     margin: '0 0 15px 0',
//                     fontSize: isMobile ? '26px' : '34px',
//                     fontWeight: 'bold',
//                     color: '#333',
//                     backgroundImage: 'linear-gradient(135deg, #A055B0 0%, #8a4b9b 100%)',
//                     backgroundClip: 'text',
//                     WebkitBackgroundClip: 'text',
//                     WebkitTextFillColor: 'transparent',
//                     textSizeAdjust: '100%',
//                     WebkitTextSizeAdjust: '100%'
//                 }}>
//                     Terms & Conditions Agreement
//                 </h1>
//             </header>

//             {/* Terms and Conditions Content - COMPLETE from original */}
//             <div style={{ lineHeight: '1.6', color: '#333' }}>
                
//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         1. Acceptance of Terms
//                     </h2>
//                     <p style={{ marginBottom: '10px', fontSize: isMobile ? '14px' : '16px' }}>
//                         Welcome to the <strong>Maamaas</strong> platform ("the Platform", "we", "us", or "our"), owned and operated by <strong>Envision Integrated Services Pvt. Ltd.</strong> These Terms and Conditions for Service Partners ("Partner Terms") govern your access to and use of the Platform as a registered service provider ("Partner", "you", or "your").
//                     </p>
//                     <p style={{ fontSize: isMobile ? '14px' : '16px' }}>
//                         By clicking "I Agree," checking a box, or by accessing or using the Platform to provide services, you acknowledge that you have read, understood, and agree to be bound by these Partner Terms, our <strong>General Terms of Use</strong>, and our <strong>Privacy Policy</strong> (collectively, the "Agreement"). If you are entering into this Agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity to these terms.
//                     </p>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         2. Definitions
//                     </h2>
//                     <div style={{
//                         backgroundColor: '#f5f5f5',
//                         padding: '15px',
//                         borderRadius: '8px',
//                         margin: '15px 0'
//                     }}>
//                         <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
//                             <strong>"Client"</strong> means an end-user who books or purchases your Services through the Platform.
//                         </p>
//                         <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
//                             <strong>"Services"</strong> means the specific services you are approved to offer and list on the Platform.
//                         </p>
//                         <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
//                             <strong>"Partner Content"</strong> means any content you upload, post, or transmit through the Platform, including your profile, descriptions, images, videos, and any communication with Clients.
//                         </p>
//                         <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
//                             <strong>"Subscription Fee"</strong> means the recurring fee you pay to access the Partner features of the Platform.
//                         </p>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px' }}>
//                             <strong>"Platform Fees"</strong> means the commission or fee we deduct from the total amount paid by the Client for your Services.
//                         </p>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         3. Partner Account and Subscription
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             3.1. Subscription:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             Access to the Platform as a Partner requires an active paid subscription. You agree to pay the Subscription Fee as outlined during the sign-up process. Fees are non-refundable except as required by law.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             3.2. Account Accuracy:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You must provide accurate, current, and complete information during the registration process and keep your account information updated at all times.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             3.3. Account Security:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You are responsible for maintaining the confidentiality of your account login credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             3.4. Approval:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             Submission of a subscription payment does not guarantee approval. We reserve the right to approve or deny any application at our sole discretion.
//                         </p>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         4. Partner Obligations and Conduct
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             4.1. Professionalism and Quality:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You agree to provide Services in a professional and workmanlike manner, consistent with generally accepted industry standards and in accordance with any descriptions and promises made on your Platform profile.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             4.2. Compliance with Laws:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You are solely responsible for complying with all applicable laws, regulations, and tax obligations of India and the State of Telangana related to your business and the Services you provide.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             4.3. Licenses and Permits:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You represent and warrant that you hold all necessary licenses, permits, insurance (such as Professional Indemnity or Public Liability, if applicable), and qualifications required to perform your Services in Hyderabad, Telangana, and any other jurisdictions where you operate.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             4.4. Prohibited Conduct:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You agree not to:
//                         </p>
//                         <ul style={{ 
//                             paddingLeft: '30px', 
//                             marginTop: '8px',
//                             fontSize: isMobile ? '14px' : '16px'
//                         }}>
//                             <li style={{ marginBottom: '5px' }}>Misrepresent your skills, experience, or qualifications.</li>
//                             <li style={{ marginBottom: '5px' }}>Post false, misleading, or defamatory content.</li>
//                             <li style={{ marginBottom: '5px' }}>Circumvent the Platform's booking and payment systems (e.g., soliciting or accepting direct payments from Clients found through the Platform).</li>
//                             <li style={{ marginBottom: '5px' }}>Discriminate against any Client on the basis of race, religion, national origin, disability, sexual orientation, sex, marital status, gender identity, age, or any other protected class.</li>
//                             <li style={{ marginBottom: '5px' }}>Use the Platform for any illegal or unauthorized purpose.</li>
//                             <li style={{ marginBottom: '5px' }}>Harass, abuse, or harm another person.</li>
//                             <li>Infringe upon the intellectual property rights of Envision Integrated Services Pvt. Ltd. or any third party.</li>
//                         </ul>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         5. Bookings, Payments, and Fees
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             5.1. Service Pricing:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You set the prices for your Services. You are responsible for ensuring these prices are accurate and include all applicable taxes as per Indian tax regulations (e.g., GST).
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             5.2. Payment Processing:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             All Client payments for Services will be processed through the Platform's designated payment gateway. We will hold the funds in escrow or according to our payment schedule.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             5.3. Platform Fees:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             In consideration for the use of the Platform, you agree that Envision Integrated Services Pvt. Ltd. will deduct a Platform Fee (a percentage of the total service cost) from each completed transaction. The current Platform Fee is 15% and is subject to change with 30 days' notice.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             5.4. Payouts:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             Payouts of your earnings (Total Service Cost minus Platform Fees) will be remitted to your designated bank account according to our payout schedule (e.g., weekly, bi-weekly). You are responsible for providing accurate payout information.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             5.5. Cancellations and Refunds:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You agree to adhere to the Platform's cancellation and refund policy. Cancellation fees may be applied to either party as per the policy.
//                         </p>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         6. Intellectual Property
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             6.1. Your Content:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You retain all ownership rights to the Partner Content you submit. However, by submitting Partner Content, you grant Envision Integrated Services Pvt. Ltd. a worldwide, non-exclusive, royalty-free, sublicensable, and transferable license to use, reproduce, distribute, and display such content for the purpose of operating, promoting, and improving the Maamaas Platform.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             6.2. Platform IP:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             Envision Integrated Services Pvt. Ltd. owns and shall retain all right, title, and interest in and to the Maamaas Platform, including all underlying software, technology, and the "Maamaas" name, logo, and trademarks.
//                         </p>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         7. Disclaimer of Warranties and Limitation of Liability
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             7.1. "As Is" Service:
//                         </h3>
//                         <p style={{ 
//                             fontSize: isMobile ? '14px' : '16px', 
//                             paddingLeft: '15px',
//                             color: '#d32f2f',
//                             fontWeight: 'bold'
//                         }}>
//                             THE MAAMAAS PLATFORM IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. ENVISION INTEGRATED SERVICES PVT. LTD. MAKES NO WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             7.2. No Liability for Client Interactions:
//                         </h3>
//                         <p style={{ 
//                             fontSize: isMobile ? '14px' : '16px', 
//                             paddingLeft: '15px',
//                             color: '#d32f2f',
//                             fontWeight: 'bold'
//                         }}>
//                             ENVISION INTEGRATED SERVICES PVT. LTD. IS NOT LIABLE FOR THE CONDUCT, ACTS, OR OMISSIONS OF ANY CLIENT. YOU BEAR ALL RISK ASSOCIATED WITH YOUR INTERACTIONS WITH CLIENTS AND THE PROVISION OF YOUR SERVICES.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             7.3. Limitation of Liability:
//                         </h3>
//                         <p style={{ 
//                             fontSize: isMobile ? '14px' : '16px', 
//                             paddingLeft: '15px',
//                             color: '#d32f2f',
//                             fontWeight: 'bold'
//                         }}>
//                             TO THE FULLEST EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF ENVISION INTEGRATED SERVICES PVT. LTD. TO YOU FOR ANY CLAIM ARISING OUT OF OR RELATING TO THIS AGREEMENT OR YOUR USE OF THE PLATFORM SHALL NOT EXCEED THE TOTAL PLATFORM FEES WE HAVE COLLECTED FROM YOU IN THE SIX (6) MONTHS PRIOR TO THE EVENT GIVING RISE TO THE CLAIM.
//                         </p>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         8. Indemnification
//                     </h2>
//                     <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                         You agree to indemnify, defend, and hold harmless <strong>Envision Integrated Services Pvt. Ltd.</strong>, its affiliates, and their respective officers, directors, employees, and agents from and against any and all claims, damages, obligations, losses, liabilities, costs, and expenses (including but not limited to attorney's fees) arising from: (i) your use of the Platform; (ii) your provision of Services; (iii) your breach of this Agreement; (iv) your violation of any law or the rights of a third party; or (v) any Client dispute.
//                     </p>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         9. Term and Termination
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             9.1. Term:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             This Agreement begins when you accept it and continues until terminated.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             9.2. Termination by You:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             You may terminate this Agreement at any time by closing your Partner account through the Platform settings.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             9.3. Termination by Us:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             We may suspend or terminate your access to the Platform and this Agreement immediately, without notice, for any reason, including but not limited to your breach of this Agreement.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             9.4. Effect of Termination:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             Upon termination, your right to use the Platform ceases immediately. Any outstanding payments owed to you for completed Services will be paid out according to our standard schedule. Sections on Intellectual Property, Disclaimer, Limitation of Liability, Indemnification, and this Section 9.4 shall survive termination.
//                         </p>
//                     </div>
//                 </section>

//                 <section style={{ marginBottom: '25px' }}>
//                     <h2 style={{
//                         color: '#A055B0',
//                         fontSize: isMobile ? '18px' : '22px',
//                         marginBottom: '10px',
//                         paddingBottom: '8px',
//                         borderBottom: '2px solid #A055B0'
//                     }}>
//                         10. General Provisions
//                     </h2>
                    
//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             10.1. Governing Law and Jurisdiction:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             This Agreement shall be governed by and construed in accordance with the laws of India. The courts in <strong>Hyderabad, Telangana, 500085</strong> shall have exclusive jurisdiction over any disputes arising under this Agreement.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             10.2. Dispute Resolution:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             The parties shall first attempt to resolve any dispute through good-faith negotiation. If the dispute cannot be resolved, it shall be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana, as stated above.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             10.3. Changes to Terms:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             We reserve the right to modify these Partner Terms at any time. We will provide notice of material changes. Your continued use of the Platform after the effective date of the revised terms constitutes your acceptance of them.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             10.4. Entire Agreement:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             This Agreement constitutes the entire understanding between you and Envision Integrated Services Pvt. Ltd. regarding the subject matter and supersedes all prior agreements.
//                         </p>
//                     </div>

//                     <div style={{ marginBottom: '15px' }}>
//                         <h3 style={{
//                             color: '#333',
//                             fontSize: isMobile ? '16px' : '18px',
//                             marginBottom: '8px'
//                         }}>
//                             10.5. Contact:
//                         </h3>
//                         <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
//                             If you have any questions about these Partner Terms, please contact us at:
//                         </p>
//                         <div style={{
//                             backgroundColor: '#f0f0f0',
//                             padding: '15px',
//                             borderRadius: '8px',
//                             marginTop: '10px',
//                             marginLeft: '15px'
//                         }}>
//                             <p style={{ margin: '5px 0', fontSize: isMobile ? '14px' : '16px' }}>
//                                 <strong>Envision Integrated Services Pvt. Ltd.</strong><br />
//                                 913, Manjeera Trinity Corporate,<br />
//                                 Kukatpally Housing Board Colony, Kukatpally,<br />
//                                 Hyderabad, Telangana 500085, India.<br />
//                                 Email: legal@maamaas.com
//                             </p>
//                         </div>
//                     </div>
//                 </section>

//                 <div style={{
//                     backgroundColor: '#fff3cd',
//                     borderLeft: '4px solid #ffc107',
//                     padding: '15px',
//                     margin: '20px 0',
//                     borderRadius: '0 8px 8px 0'
//                 }}>
//                     <p style={{ 
//                         margin: 0,
//                         fontSize: isMobile ? '14px' : '16px',
//                         color: '#856404',
//                         fontWeight: 'bold'
//                     }}>
//                         <FaExclamationTriangle aria-hidden="true" style={{ marginRight: '10px' }} />
//                         Important Notice: By agreeing to these terms, you confirm you've read and understood all policies. Terms may change with notice. We reserve the right to refuse service at any time.
//                     </p>
//                 </div>
//             </div>

//             {/* Agreement Section */}
//             <section 
//                 aria-label="Agreement Section"
//                 style={{
//                     marginBottom: '10px',
//                     padding: '25px 0',
//                     borderTop: '2px solid #f0f0f0',
//                     //borderBottom: '2px solid #f0f0f0'
//                 }}
//             >
//                 <div style={{
//                     display: 'flex',
//                     alignItems: 'flex-start',
//                     gap: '20px',
//                     flexDirection: isMobile ? 'column' : 'row'
//                 }}>
//                     <div style={{
//                         flexShrink: 0,
//                         position: 'relative'
//                     }}>
//                         <input 
//                             type="checkbox" 
//                             id="termsAgreement"
//                             checked={agreed}
//                             onChange={(e) => setAgreed(e.target.checked)}
//                             aria-labelledby="termsAgreementLabel"
//                             style={{
//                                 position: 'absolute',
//                                 opacity: 0,
//                                 width: 0,
//                                 height: 0
//                             }}
//                         />
//                         <label 
//                             htmlFor="termsAgreement"
//                             title="Agree to Terms and Conditions checkbox"
//                             style={{
//                                 display: 'block',
//                                 width: '36px',
//                                 height: '36px',
//                                 borderRadius: '6px',
//                                 border: `2px solid ${agreed ? '#4CAF50' : '#ddd'}`,
//                                 background: agreed ? '#4CAF50' : 'white',
//                                 cursor: 'pointer',
//                                 transition: 'all 0.3s ease',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 fontSize: '18px',
//                                 color: 'white',
//                                 fontWeight: 'bold'
//                             }}
//                         >
//                             {agreed && <FaCheckCircle aria-hidden="true" />}
//                         </label>
//                     </div>
                    
//                     <div style={{ flex: 1 }}>
//                         <label 
//                             id="termsAgreementLabel"
//                             htmlFor="termsAgreement"
//                             style={{
//                                 display: 'block',
//                                 fontSize: isMobile ? '18px' : '20px',
//                                 fontWeight: 'bold',
//                                 color: agreed ? '#2e7d32' : '#333',
//                                 cursor: 'pointer',
//                                 lineHeight: '1.5',
//                                 marginBottom: '8px'
//                         }}>
//                             {agreed ? '✓ I agree to the Terms & Conditions' : 'I agree to the Terms & Conditions'}
//                         </label>
//                         <p style={{
//                             margin: 0,
//                             fontSize: '15px',
//                             color: agreed ? '#4CAF50' : '#666',
//                             lineHeight: '1.6'
//                         }}>
//                             {agreed 
//                                 ? 'You have read and agreed to all terms and conditions stated above.'
//                                 : 'You must read and agree to the Terms and Conditions before proceeding to Vendor Guidelines.'
//                             }
//                         </p>
//                         {autoAgree && agreed && (
//                             <div style={{
//                                 marginTop: '10px',
//                                 padding: '8px 12px',
//                                 backgroundColor: '#e8f5e9',
//                                 borderRadius: '6px',
//                                 fontSize: '14px',
//                                 color: '#2e7d32',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '8px'
//                             }}>
//                                 <FaCheckCircle aria-hidden="true" />
//                                 Auto-agreed for convenience
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </section>

//             {/* Navigation Buttons
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 paddingTop: '20px',
//                 flexDirection: isMobile ? 'column' : 'row',
//                 gap: isMobile ? '15px' : '0'
//             }}>
//                 <button 
//                     onClick={handleBack}
//                     aria-label="Go back to Privacy Policy"
//                     style={{
//                         padding: isMobile ? '14px 30px' : '16px 40px',
//                         borderRadius: '8px',
//                         border: '2px solid #A055B0',
//                         background: 'white',
//                         color: '#A055B0',
//                         cursor: 'pointer',
//                         fontSize: isMobile ? '10px' : '16px',
//                         fontWeight: '600',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         gap: '10px',
//                         transition: 'all 0.3s ease',
//                         minWidth: '130px',
//                         order: isMobile ? 2 : 1
//                     }}
//                     onMouseEnter={(e) => {
//                         e.currentTarget.style.backgroundColor = '#f5f0f7';
//                         e.currentTarget.style.transform = 'translateY(-2px)';
//                     }}
//                     onMouseLeave={(e) => {
//                         e.currentTarget.style.backgroundColor = 'white';
//                         e.currentTarget.style.transform = 'translateY(0)';
//                     }}
//                 >
//                     ← Previous
//                 </button>

//                 <button 
//                     onClick={handleNext}
//                     disabled={!agreed}
//                     aria-label={agreed ? "Proceed to Vendor Guidelines" : "Please agree to terms first"}
//                     title={agreed ? "Navigate to Vendor Guidelines" : "You must agree to the terms first"}
//                     style={{
//                         padding: isMobile ? '14px 30px' : '16px 40px',
//                         borderRadius: '8px',
//                         border: 'none',
//                         background: agreed ? 'linear-gradient(135deg, #A055B0 0%, #8a4b9b 100%)' : '#e0e0e0',
//                         color: agreed ? 'white' : '#999',
//                         cursor: agreed ? 'pointer' : 'not-allowed',
//                         fontSize: isMobile ? '14px' : '16px',
//                         fontWeight: '600',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         gap: '10px',
//                         transition: agreed ? 'all 0.3s ease' : 'none',
//                         boxShadow: agreed ? '0 4px 12px rgba(160, 85, 176, 0.2)' : 'none',
//                         minWidth: '130px',
//                         order: 1
//                     }}
//                     onMouseEnter={(e) => {
//                         if (agreed) {
//                             e.currentTarget.style.transform = 'translateY(-2px)';
//                             e.currentTarget.style.boxShadow = '0 6px 16px rgba(160, 85, 176, 0.3)';
//                         }
//                     }}
//                     onMouseLeave={(e) => {
//                         if (agreed) {
//                             e.currentTarget.style.transform = 'translateY(0)';
//                             e.currentTarget.style.boxShadow = '0 4px 12px rgba(160, 85, 176, 0.2)';
//                         }
//                     }}
//                 >
//                     {agreed ? (
//                         <>
//                             Next
//                             <FaArrowRight aria-hidden="true" />
//                         </>
//                     ) : (
//                         'Next'
//                     )}
//                 </button>
//             </div> */}

//             <SuccessModal 
//                 isOpen={showSuccessModal}
//                 onClose={() => setShowSuccessModal(false)}
//                 message="You have successfully agreed to the Terms & Conditions. You can now proceed to Vendor Guidelines."
//                 title="Terms Accepted!"
//             />
//         </div>
//     );
// };

// export default TermsConditions;




















// import React, { useState, useEffect } from "react";
// import {
//   FaCheckCircle,
//   FaExclamationTriangle,
//   FaTimes
// } from "react-icons/fa";

// const TermsConditions = ({ isMobile, autoAgree = false }) => {
//   const [agreed, setAgreed] = useState(false);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   const userRole = localStorage.getItem("role") || "VENDOR";

//   useEffect(() => {
//     if (autoAgree) setAgreed(true);
//   }, [autoAgree]);

//   const handleNext = () => {
//     if (!agreed) {
//       alert("Please agree to the Terms & Conditions");
//       return;
//     }

//     const data = {
//       agreed: true,
//       role: userRole,
//       agreedDate: new Date().toISOString(),
//       userId:
//         userRole === "SUPER_ADMIN"
//           ? localStorage.getItem("adminId")
//           : localStorage.getItem("vendorId"),
//       email:
//         userRole === "SUPER_ADMIN"
//           ? localStorage.getItem("adminEmail")
//           : localStorage.getItem("vendorEmail"),
//       termsVersion: "v1.5",
//       submissionId: `TNC-${Date.now()}`
//     };

//     console.log("Agreement Submitted:", data);
//     setShowSuccessModal(true);
//   };

//   const SuccessModal = ({ isOpen, onClose }) => {
//     if (!isOpen) return null;

//     return (
//       <div style={overlayStyle}>
//         <div style={modalStyle}>
//           <button onClick={onClose} style={closeBtn}>
//             <FaTimes />
//           </button>
//           <FaCheckCircle style={{ fontSize: 50, color: "#4CAF50" }} />
//           <h2>Terms Accepted</h2>
//           <p>
//             You have successfully agreed to the Terms & Conditions.
//           </p>
//           <button onClick={onClose} style={okBtn}>
//             OK
//           </button>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div style={container}>
//       <h1 style={title}>Terms & Conditions</h1>

//       {/* COMMON TERMS */}
//       <Section title="1. Acceptance of Terms">
//         By accessing and using the Maamaas Platform, you agree to
//         comply with all applicable terms, policies, and legal
//         obligations.
//       </Section>

//       <Section title="2. Partner Responsibilities">
//         Vendors must provide accurate information, comply with
//         Indian laws, and maintain professional conduct while using
//         the platform.
//       </Section>

//       <Section title="3. Payments & Fees">
//         Platform fees, subscriptions, and payouts are governed by
//         Maamaas financial policies and are subject to change.
//       </Section>

//       {/* SUPER ADMIN TERMS */}
//       {userRole === "SUPER_ADMIN" && (
//         <Section title="4. Super Admin Rights & Authority">
//           <ul>
//             <li>Full control over vendors, services & users</li>
//             <li>Access platform data for audits & compliance</li>
//             <li>Modify platform fees & subscriptions</li>
//             <li>Remove or suspend accounts violating policies</li>
//             <li>
//               Ensure data security and system integrity at all
//               times
//             </li>
//           </ul>
//         </Section>
//       )}

//       <div style={warningBox}>
//         <FaExclamationTriangle /> &nbsp; By agreeing, you confirm
//         that you understand and accept all platform policies.
//       </div>

//       {/* AGREEMENT */}
//       <div style={agreeBox}>
//         <input
//           type="checkbox"
//           checked={agreed}
//           onChange={(e) => setAgreed(e.target.checked)}
//         />
//         <label>
//           I agree to the Terms & Conditions
//           {userRole === "SUPER_ADMIN" && " as Super Admin"}
//         </label>
//       </div>

//       <button
//         disabled={!agreed}
//         onClick={handleNext}
//         style={{
//           ...nextBtn,
//           opacity: agreed ? 1 : 0.5
//         }}
//       >
//         Continue
//       </button>

//       <SuccessModal
//         isOpen={showSuccessModal}
//         onClose={() => setShowSuccessModal(false)}
//       />
//     </div>
//   );
// };

// /* -------------------- Helpers -------------------- */

// const Section = ({ title, children }) => (
//   <div style={{ marginBottom: 20 }}>
//     <h3 style={{ color: "#8a4b9b" }}>{title}</h3>
//     <div style={{ color: "#333", lineHeight: 1.6 }}>{children}</div>
//   </div>
// );

// /* -------------------- Styles -------------------- */

// const container = {
//   background: "#fff",
//   padding: 25,
//   borderRadius: 10,
//   maxHeight: "80vh",
//   overflowY: "auto"
// };

// const title = {
//   textAlign: "center",
//   color: "#8a4b9b",
//   marginBottom: 20
// };

// const warningBox = {
//   background: "#fff3cd",
//   padding: 15,
//   borderLeft: "4px solid #ffc107",
//   marginBottom: 20,
//   borderRadius: 6
// };

// const agreeBox = {
//   display: "flex",
//   alignItems: "center",
//   gap: 10,
//   marginBottom: 20
// };

// const nextBtn = {
//   width: "100%",
//   padding: 14,
//   borderRadius: 8,
//   border: "none",
//   background: "#8a4b9b",
//   color: "#fff",
//   fontSize: 16,
//   cursor: "pointer"
// };

// const overlayStyle = {
//   position: "fixed",
//   inset: 0,
//   background: "rgba(0,0,0,0.5)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   zIndex: 9999
// };

// const modalStyle = {
//   background: "#fff",
//   padding: 30,
//   borderRadius: 12,
//   textAlign: "center",
//   position: "relative",
//   width: 320
// };

// const closeBtn = {
//   position: "absolute",
//   top: 10,
//   right: 10,
//   border: "none",
//   background: "transparent",
//   cursor: "pointer"
// };

// const okBtn = {
//   marginTop: 15,
//   padding: "10px 30px",
//   borderRadius: 20,
//   border: "none",
//   background: "#4CAF50",
//   color: "#fff",
//   cursor: "pointer"
// };

// export default TermsConditions;




















import React, { useState, useEffect } from "react";
import { 
  FaCheckCircle, 
  FaExclamationTriangle, 
  FaDatabase, 
  FaShieldAlt, 
  FaGavel, 
  FaBook, 
  FaTimes, 
  FaArrowRight,
  FaUserShield,
  FaChartLine,
  FaClipboardCheck,
  FaLock
} from "react-icons/fa";

const TermsConditions = ({ isMobile, autoAgree = false }) => {
    const [agreed, setAgreed] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    useEffect(() => {
        if (autoAgree) {
            setAgreed(true);
        }
    }, [autoAgree]);

    const handleNext = () => {
        if (!agreed) {
            alert("Please read and agree to the SuperAdmin Terms & Conditions before proceeding.");
            return;
        }

        const data = {
            agreed: true,
            agreedDate: new Date().toISOString(),
            superAdminId: localStorage.getItem("superAdminId") || "",
            superAdminName: localStorage.getItem("superAdminName") || "System Administrator",
            termsVersion: "v2.0-SUPERADMIN",
            submissionId: `SA-TNC-${Date.now()}`,
            adminLevel: localStorage.getItem("adminLevel") || "Platform Administrator"
        };

        setShowSuccessModal(true);
    };

    const handleBack = () => {
        // console.log("Navigate back to SuperAdmin Privacy Policy");
    };

    const SuccessModal = ({ isOpen, onClose, message, title = "SuperAdmin Terms Accepted!" }) => {
        if (!isOpen) return null;
      
        return (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            padding: '20px'
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: window.innerWidth < 768 ? '20px' : '30px',
              maxWidth: window.innerWidth < 768 ? '90%' : '500px',
              width: '100%',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
              position: 'relative'
            }}>
              <button 
                onClick={onClose}
                aria-label="Close success modal"
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  color: '#666',
                  cursor: 'pointer',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                  e.currentTarget.style.color = '#333';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#666';
                }}
              >
                <FaTimes aria-hidden="true" />
              </button>
      
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#1a237e',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: 'scaleIn 0.5s ease-out'
                }}>
                  <FaUserShield aria-hidden="true" style={{ color: 'white', fontSize: '40px' }} />
                </div>
              </div>
      
              <h3 style={{
                textAlign: 'center',
                color: '#1a237e',
                margin: '0 0 15px 0',
                fontSize: window.innerWidth < 768 ? '22px' : '24px',
                fontWeight: 'bold'
              }}>
                {title}
              </h3>
      
              <div style={{
                textAlign: 'center',
                color: '#555',
                fontSize: window.innerWidth < 768 ? '16px' : '18px',
                lineHeight: '1.5',
                marginBottom: '25px',
                padding: '0 10px'
              }}>
                {message}
              </div>
      
              <div style={{ textAlign: 'center' }}>
                <button 
                  onClick={onClose}
                  aria-label="Close success message"
                  style={{
                    backgroundColor: '#1a237e',
                    color: 'white',
                    border: 'none',
                    padding: window.innerWidth < 768 ? '12px 30px' : '14px 40px',
                    borderRadius: '50px',
                    cursor: 'pointer',
                    fontSize: window.innerWidth < 768 ? '16px' : '18px',
                    fontWeight: 'bold',
                    minWidth: '150px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(26, 35, 126, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#283593';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(26, 35, 126, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#1a237e';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(26, 35, 126, 0.3)';
                  }}
                >
                  Acknowledge
                </button>
              </div>
            </div>
      
            <style>{`
              @keyframes scaleIn {
                from {
                  transform: scale(0);
                  opacity: 0;
                }
                to {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            `}</style>
          </div>
        );
      };

    return (
        <div 
            style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                padding: isMobile ? "15px" : "25px",
                border: "1px solid #e0e0e0",
                minHeight: "400px",
                overflow: "auto",
                scrollbarWidth: "none",
                maxHeight: isMobile ? "600px" : "700px"
            }}
        >
            {/* Header */}
            <header style={{
                textAlign: 'center',
                marginBottom: '30px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '15px',
                    marginBottom: '15px'
                }}>
                    <FaUserShield aria-hidden="true" style={{ 
                        fontSize: isMobile ? '36px' : '48px',
                        color: '#1a237e'
                    }} />
                    <h1 style={{
                        margin: 0,
                        fontSize: isMobile ? '26px' : '34px',
                        fontWeight: 'bold',
                        color: '#333',
                        backgroundImage: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        textSizeAdjust: '100%',
                        WebkitTextSizeAdjust: '100%'
                    }}>
                        SuperAdmin Platform Agreement
                    </h1>
                </div>
                <p style={{
                    color: '#666',
                    fontSize: isMobile ? '14px' : '16px',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    Platform Administration, Governance, and Security Terms for Envision Integrated Services
                </p>
            </header>

            {/* Terms and Conditions Content - UPDATED FOR SUPERADMIN */}
            <div style={{ lineHeight: '1.6', color: '#333' }}>
                
                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <FaLock aria-hidden="true" />
                        1. SuperAdmin Authorization & Scope
                    </h2>
                    <p style={{ marginBottom: '10px', fontSize: isMobile ? '14px' : '16px' }}>
                        This <strong>SuperAdmin Platform Agreement</strong> ("Admin Agreement") governs your access and use of the Maamaas platform administrative controls, dashboard, and backend systems ("Admin Platform") as a designated Super Administrator ("SuperAdmin", "you") of <strong>Envision Integrated Services Pvt. Ltd.</strong>
                    </p>
                    <p style={{ fontSize: isMobile ? '14px' : '16px' }}>
                        By accepting these terms, you acknowledge elevated privileges, heightened security responsibilities, and binding obligations regarding platform governance, data protection, and administrative conduct. Unauthorized access or misuse constitutes a material breach and may result in legal action.
                    </p>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <FaShieldAlt aria-hidden="true" />
                        2. Administrative Privileges & Responsibilities
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FaUserShield aria-hidden="true" />
                            2.1. Privilege Classification:
                        </h3>
                        <div style={{
                            backgroundColor: '#f5f7ff',
                            padding: '15px',
                            borderRadius: '8px',
                            margin: '10px 0 10px 15px',
                            borderLeft: '3px solid #1a237e'
                        }}>
                            <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
                                <strong>Tier-1 (Platform Administrator):</strong> Full system access including vendor management, financial oversight, security configurations, and audit logs.
                            </p>
                            <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
                                <strong>Tier-2 (Compliance Administrator):</strong> Regulatory oversight, data governance, compliance reporting, and policy enforcement.
                            </p>
                            <p style={{ marginBottom: '8px', fontSize: isMobile ? '14px' : '16px' }}>
                                <strong>Tier-3 (Technical Administrator):</strong> System maintenance, API management, database access, and technical configurations.
                            </p>
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FaDatabase aria-hidden="true" />
                            2.2. Data Governance:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            You are responsible for maintaining data integrity, enforcing retention policies, managing backups, and ensuring GDPR/CCPA compliance across all platform data. All administrative data access is logged and monitored.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <FaClipboardCheck aria-hidden="true" />
                            2.3. Security Protocols:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Mandatory use of multi-factor authentication, regular password rotation (every 90 days), encrypted communications, and adherence to the Principle of Least Privilege (PoLP) for all administrative actions.
                        </p>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <FaGavel aria-hidden="true" />
                        3. Compliance & Regulatory Oversight
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            3.1. Platform-Wide Compliance:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            You are responsible for ensuring the entire platform ecosystem complies with:
                        </p>
                        <ul style={{ 
                            paddingLeft: '30px', 
                            marginTop: '8px',
                            fontSize: isMobile ? '14px' : '16px'
                        }}>
                            <li style={{ marginBottom: '5px' }}>Indian IT Act, 2000 and subsequent amendments</li>
                            <li style={{ marginBottom: '5px' }}>GDPR (for international users) and CCPA regulations</li>
                            <li style={{ marginBottom: '5px' }}>PCI-DSS Level 1 for payment processing</li>
                            <li style={{ marginBottom: '5px' }}>FSSAI regulations for food service vendors</li>
                            <li>Digital Personal Data Protection Act, 2023 (when effective)</li>
                        </ul>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            3.2. Audit Trail Management:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            All SuperAdmin actions generate immutable audit logs with timestamp, IP address, action taken, and affected entities. These logs are retained for 10 years and are subject to regulatory review.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            3.3. Incident Reporting:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Security incidents, data breaches, or compliance violations must be reported immediately to the Security Operations Center (SOC) and documented according to incident response protocols.
                        </p>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <FaChartLine aria-hidden="true" />
                        4. Vendor & Platform Management
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            4.1. Vendor Oversight:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Authority to approve, suspend, or terminate vendor accounts based on compliance violations, quality metrics, or platform policy breaches. All actions must be documented with justification.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            4.2. Financial Administration:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Oversight of payment processing, fee collection, payout schedules, and financial reconciliation. Access to financial reports requires additional authorization from Finance Department.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            4.3. System Configuration:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Modification of platform settings, feature toggles, API configurations, and third-party integrations. All changes require peer review for Tier-1 and above modifications.
                        </p>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        5. Prohibited Administrative Actions
                    </h2>
                    <div style={{
                        backgroundColor: '#fff5f5',
                        padding: '20px',
                        borderRadius: '8px',
                        borderLeft: '4px solid #d32f2f',
                        margin: '15px 0'
                    }}>
                        <p style={{ marginBottom: '10px', fontSize: isMobile ? '14px' : '16px', fontWeight: 'bold', color: '#d32f2f' }}>
                            STRICTLY PROHIBITED - Grounds for immediate termination and legal action:
                        </p>
                        <ul style={{ 
                            paddingLeft: '20px', 
                            fontSize: isMobile ? '14px' : '16px'
                        }}>
                            <li style={{ marginBottom: '8px' }}>Accessing or modifying personal data without legitimate business purpose</li>
                            <li style={{ marginBottom: '8px' }}>Circumventing security controls or audit logging mechanisms</li>
                            <li style={{ marginBottom: '8px' }}>Creating unauthorized administrative accounts or privilege escalation</li>
                            <li style={{ marginBottom: '8px' }}>Using platform resources for personal gain or unauthorized purposes</li>
                            <li style={{ marginBottom: '8px' }}>Disclosing platform vulnerabilities without following responsible disclosure</li>
                            <li>Exporting platform data without proper authorization and encryption</li>
                        </ul>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        6. Data Protection & Confidentiality
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            6.1. Confidential Information:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            You agree to maintain strict confidentiality of all platform data, including vendor information, financial records, user data, security protocols, and proprietary algorithms. This obligation survives termination of your admin access.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            6.2. Data Encryption Standards:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            All administrative data exports, backups, and transfers must use AES-256 encryption. Encryption keys are managed by separate Key Management Administrators.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            6.3. Breach Notification:
                        </h3>
                        <p style={{ 
                            fontSize: isMobile ? '14px' : '16px', 
                            paddingLeft: '15px',
                            color: '#d32f2f',
                            fontWeight: 'bold'
                        }}>
                            Failure to report data breaches within 24 hours of discovery constitutes gross negligence and may result in personal liability for damages.
                        </p>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        7. Liability & Indemnification
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            7.1. Personal Liability:
                        </h3>
                        <p style={{ 
                            fontSize: isMobile ? '14px' : '16px', 
                            paddingLeft: '15px',
                            color: '#d32f2f',
                            fontWeight: 'bold'
                        }}>
                            SuperAdmins may be held personally liable for damages resulting from gross negligence, willful misconduct, or violation of this agreement.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            7.2. Indemnification:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            You agree to indemnify and hold harmless <strong>Envision Integrated Services Pvt. Ltd.</strong> from all claims, damages, and expenses arising from your breach of this agreement or negligent administration of the platform.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            7.3. Insurance Requirements:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            SuperAdmins handling financial or sensitive data must maintain Professional Indemnity Insurance of at least ₹5,000,000 (Five Million Rupees).
                        </p>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        8. Termination & Transition
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            8.1. Access Termination:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Admin access may be terminated immediately for security violations, compliance breaches, or at the discretion of the Security Committee. All access logs and activities are preserved for audit.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            8.2. Knowledge Transfer:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            Upon termination, you must provide all documentation, credentials, and knowledge necessary for administrative continuity. Retention of platform data post-termination is strictly prohibited.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            8.3. Post-Termination Audit:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            All administrative actions during your tenure remain subject to audit for 5 years post-termination. You agree to cooperate with any audit requests.
                        </p>
                    </div>
                </section>

                <section style={{ marginBottom: '25px' }}>
                    <h2 style={{
                        color: '#1a237e',
                        fontSize: isMobile ? '18px' : '22px',
                        marginBottom: '10px',
                        paddingBottom: '8px',
                        borderBottom: '2px solid #1a237e'
                    }}>
                        9. General Provisions
                    </h2>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            9.1. Governing Law:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            This Agreement shall be governed by and construed in accordance with the laws of India. Exclusive jurisdiction resides with the courts in <strong>Hyderabad, Telangana</strong>.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            9.2. Amendments:
                        </h3>
                        <p style={{ fontSize: isMobile ? '14px' : '16px', paddingLeft: '15px' }}>
                            These terms may be updated with 15 days' notice. Continued use of admin privileges constitutes acceptance of revised terms.
                        </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <h3 style={{
                            color: '#333',
                            fontSize: isMobile ? '16px' : '18px',
                            marginBottom: '8px'
                        }}>
                            9.3. Security Operations Center:
                        </h3>
                        <div style={{
                            backgroundColor: '#e8eaf6',
                            padding: '15px',
                            borderRadius: '8px',
                            marginTop: '10px',
                            marginLeft: '15px'
                        }}>
                            <p style={{ margin: '5px 0', fontSize: isMobile ? '14px' : '16px' }}>
                                <strong>Envision Integrated Services - Security Operations</strong><br />
                                24/7 Hotline: +91-XXXXXXXXXX<br />
                                Emergency Email: soc@envision-services.com<br />
                                Incident Reporting Portal: https://soc.maamaas.com
                            </p>
                        </div>
                    </div>
                </section>

                <div style={{
                    backgroundColor: '#ffebee',
                    borderLeft: '4px solid #d32f2f',
                    padding: '15px',
                    margin: '20px 0',
                    borderRadius: '0 8px 8px 0'
                }}>
                    <p style={{ 
                        margin: 0,
                        fontSize: isMobile ? '14px' : '16px',
                        color: '#c62828',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px'
                    }}>
                        <FaExclamationTriangle aria-hidden="true" style={{ flexShrink: 0, marginTop: '2px' }} />
                        <span>
                            <strong>CRITICAL NOTICE:</strong> SuperAdmin privileges grant elevated access with significant legal and security responsibilities. All actions are logged and monitored. Violations may result in termination, legal action, and criminal prosecution under Indian cyber laws.
                        </span>
                    </p>
                </div>
            </div>

            {/* Agreement Section */}
            <section 
                aria-label="SuperAdmin Agreement Section"
                style={{
                    marginBottom: '10px',
                    padding: '25px 0',
                    borderTop: '2px solid #f0f0f0'
                }}
            >
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '20px',
                    flexDirection: isMobile ? 'column' : 'row'
                }}>
                    <div style={{
                        flexShrink: 0,
                        position: 'relative'
                    }}>
                        <input 
                            type="checkbox" 
                            id="superadminTermsAgreement"
                            checked={agreed}
                            onChange={(e) => setAgreed(e.target.checked)}
                            aria-labelledby="superadminTermsAgreementLabel"
                            style={{
                                position: 'absolute',
                                opacity: 0,
                                width: 0,
                                height: 0
                            }}
                        />
                        <label 
                            htmlFor="superadminTermsAgreement"
                            title="Agree to SuperAdmin Terms and Conditions checkbox"
                            style={{
                                display: 'block',
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                border: `2px solid ${agreed ? '#1a237e' : '#ddd'}`,
                                background: agreed ? '#1a237e' : 'white',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px',
                                color: 'white',
                                fontWeight: 'bold'
                            }}
                        >
                            {agreed && <FaCheckCircle aria-hidden="true" />}
                        </label>
                    </div>
                    
                    <div style={{ flex: 1 }}>
                        <label 
                            id="superadminTermsAgreementLabel"
                            htmlFor="superadminTermsAgreement"
                            style={{
                                display: 'block',
                                fontSize: isMobile ? '18px' : '20px',
                                fontWeight: 'bold',
                                color: agreed ? '#1a237e' : '#333',
                                cursor: 'pointer',
                                lineHeight: '1.5',
                                marginBottom: '8px'
                        }}>
                            {agreed ? '✓ I ACCEPT SuperAdmin Platform Agreement' : 'I ACCEPT SuperAdmin Platform Agreement'}
                        </label>
                        <p style={{
                            margin: 0,
                            fontSize: '15px',
                            color: agreed ? '#1a237e' : '#666',
                            lineHeight: '1.6'
                        }}>
                            {agreed 
                                ? 'You acknowledge heightened security responsibilities, compliance obligations, and potential personal liability.'
                                : 'You must acknowledge and accept all administrative responsibilities, security protocols, and legal obligations.'
                            }
                        </p>
                        {autoAgree && agreed && (
                            <div style={{
                                marginTop: '10px',
                                padding: '8px 12px',
                                backgroundColor: '#e8eaf6',
                                borderRadius: '6px',
                                fontSize: '14px',
                                color: '#1a237e',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <FaCheckCircle aria-hidden="true" />
                                Administrative privileges auto-confirmed
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Navigation Buttons */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '20px',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '15px' : '0'
            }}>
                <button 
                    onClick={handleBack}
                    aria-label="Go back to Privacy Policy"
                    style={{
                        padding: isMobile ? '14px 30px' : '16px 40px',
                        borderRadius: '8px',
                        border: '2px solid #1a237e',
                        background: 'white',
                        color: '#1a237e',
                        cursor: 'pointer',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        transition: 'all 0.3s ease',
                        minWidth: '130px',
                        order: isMobile ? 2 : 1
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f7ff';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'white';
                        e.currentTarget.style.transform = 'translateY(0)';
                    }}
                >
                    ← Back to Security Policies
                </button>

                <button 
                    onClick={handleNext}
                    disabled={!agreed}
                    aria-label={agreed ? "Proceed to Platform Administration" : "Please accept SuperAdmin terms first"}
                    title={agreed ? "Navigate to Platform Administration" : "You must accept SuperAdmin terms first"}
                    style={{
                        padding: isMobile ? '14px 30px' : '16px 40px',
                        borderRadius: '8px',
                        border: 'none',
                        background: agreed ? 'linear-gradient(135deg, #1a237e 0%, #283593 100%)' : '#e0e0e0',
                        color: agreed ? 'white' : '#999',
                        cursor: agreed ? 'pointer' : 'not-allowed',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        transition: agreed ? 'all 0.3s ease' : 'none',
                        boxShadow: agreed ? '0 4px 12px rgba(26, 35, 126, 0.2)' : 'none',
                        minWidth: '130px',
                        order: 1
                    }}
                    onMouseEnter={(e) => {
                        if (agreed) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(26, 35, 126, 0.3)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (agreed) {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(26, 35, 126, 0.2)';
                        }
                    }}
                >
                    {agreed ? (
                        <>
                            Access Platform Admin
                            <FaArrowRight aria-hidden="true" />
                        </>
                    ) : (
                        'Accept Terms to Proceed'
                    )}
                </button>
            </div>

            <SuccessModal 
                isOpen={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                message="SuperAdmin privileges have been activated. All administrative actions are now being logged and monitored by the Security Operations Center."
                title="SuperAdmin Access Granted!"
            />
        </div>
    );
};

export default TermsConditions;